import { IonAlert, IonCard, IonLabel } from "@ionic/react";
import React, { useState } from "react";
import "./ReminderCard.scss";
import { utilService } from "../../../../../../../../../../services/utilService";
import {
  RespUpdatedReminderCardInterface,
  updatedReminderCardParams,
} from "./Models/UpdatedReminderCard.model";
import { useToast } from "@agney/ir-toast";
import { statusBoardService } from "../../../../../../../../StatusBoard.service";
import { reminderService } from "../../Reminder.service";
import { doctorCardService } from "../../../../../../../../../../components/Shared/DoctorList/Components/DoctorCard/doctor-card-service";
import { displayReminderContainerModel } from "../../Models/Reminder.model";
import { ReminderAlertService } from "../../../../../../../../../../services/ReminderAlert.service";
import { statusBoardSocketService } from "../../../../../../../../StatusBoardSocketService";

interface reminderParams {
  reminderData: displayReminderContainerModel;
  refreshReminderData: (data: any) => void;
}

const ReminderCard: React.FC<reminderParams> = (props) => {
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isLoaderActive, setLoaderStatus] = useState(true);

  const Toast = useToast();

  async function updatedReminderCardList(addParams: updatedReminderCardParams) {
    setLoaderStatus(true);
    const respReminderUpdatedCardResult: RespUpdatedReminderCardInterface =
      await reminderService.getUpdatedReminderCardList(addParams);
    if (respReminderUpdatedCardResult.isSuccess) {
      props.refreshReminderData(
        respReminderUpdatedCardResult.displayUpdatedReminderCard
      );
      ReminderAlertService.clearTimeOutOfDeletedCard(
        addParams.remove_reminder_id
      );
      const socketParams = {
        type: "reminders",
      };
      statusBoardSocketService.sendSbInputSocketParams(socketParams);
      Toast.success("Reminder removed successfully");
    } else {
      reminderService.handleErrorResponse();
    }
    setLoaderStatus(false);
  }

  const proceedDeleteNote = (key: any) => {
    const addParams = {
      bedId: statusBoardService.rowData.id,
      reg_code: utilService.getNetwork(),
      remove_reminder_id: key,
      statusBoardID: statusBoardService.statusBoardId,
    };
    updatedReminderCardList(addParams);
  };

  return (
    <IonCard
      className="reminder-card-wrapper"
      id={`reminderCardId-${props.reminderData.id}`}
    >
      <div className="time-data">
        <IonLabel
          className="close"
          onClick={() => setIsShowAlert(true)}
          padding-right
        >
          <span className="input-icon icon-close"></span>
        </IonLabel>
        <IonAlert
          isOpen={isShowAlert}
          onDidDismiss={() => setIsShowAlert(false)}
          cssClass="sms-alert"
          header="Confirmation!"
          message="Are you sure you want to delete reminder?"
          buttons={[
            {
              text: "NO",
              role: "cancel",
              cssClass: "secondary",
            },
            {
              text: "OK",
              handler: () => {
                proceedDeleteNote(props.reminderData.id);
              },
            },
          ]}
        />
      </div>
      <div className="reminder-card-data">
        <div className="data-header">
          <div className="doc-name">
            {doctorCardService.availabilityTimeFormat(props.reminderData.time)}
          </div>

          <div className="notes-time">{props.reminderData.title}</div>
        </div>
      </div>
    </IonCard>
  );
};

export default ReminderCard;
